import { customDispatch } from "@affinity/Store/ServiceBase";
import { defaultAccountModel, defaultBillToModel } from "@affinity/Store/StoreTypeStates";
import { createHandlerChainRunner, Handler, HasOnError, makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { updateAccount, UpdateAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { addAccount as addAccountApi, AddAccountApiParameter, updateAccountWithResult as updateAccountApiWithResult } from "@insite/client-framework/Services/AccountService";
import { getBillTo } from "@insite/client-framework/Services/CustomersService";
import { getSession, stopWatchingForOtherTabSessionChange, watchForOtherTabSessionChange } from "@insite/client-framework/Services/SessionService";
import LoadSession from "@insite/client-framework/Store/Context/Handlers/LoadSession";
import addAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { AccountModel, BillToModel } from "@insite/client-framework/Types/ApiModels";
import add from "lodash/add"
import update from "lodash/update"

// External parameters
interface CreateAccountParameters {
    firstName: string,
    lastName: string,
    contactNumber: string,
    emailAddress: string,
    password: string,
}

// Internal parameters
interface Props {
    billTo: BillToModel | undefined,
    error: string,
    statusError: string,
    account: AccountModel,
    // apiParamater: AddAccountApiParameter,
    // result: AccountModel,
}

type Parameter = CreateAccountParameters & HasOnError<Props>;

type HandlerType = Handler<Parameter, Props>;

const FireOnError: HandlerType = props => {
    if(props.statusError){
        props.parameter.onError?.(props);
    }
};

const CreateAccount: HandlerType = async props => {

    props.statusError = "";
    stopWatchingForOtherTabSessionChange();
    const apiParamater: AddAccountApiParameter = {
        account: {
        ...defaultAccountModel,
        firstName: props.parameter.firstName,
        lastName: props.parameter.lastName,
        userName: props.parameter.emailAddress,
        password: props.parameter.password,
        email: props.parameter.emailAddress,
        isSubscribed: false,
        isApproved: true,
        isGuest: false,
        },
    }
    const apiResult = await addAccountApi(apiParamater);
    if (apiResult.successful) {
        props.account = apiResult.result;
        watchForOtherTabSessionChange();
    }else{
        props.statusError = apiResult.errorMessage;
    }

    
    /*
    const awaitableAddAccount = makeHandlerChainAwaitable(addAccount);
    await awaitableAddAccount({
        email: props.parameter.emailAddress,
        userName: props.parameter.emailAddress,
        password: props.parameter.password,
        isSubscribed: false,
        onComplete: (callback) => {
            if (callback.apiResult?.successful) {
                props.account = callback.apiResult.result
            }
        }
    })(props.dispatch, props.getState);
    */
};

/*
const UpdateAccount: HandlerType = async props => {
    const updatedAccount = props.account;
    updatedAccount.properties["phone"] = props.parameter.contactNumber;
    const apiParamater: UpdateAccountApiParameter = {
        account: updatedAccount,
    }
    const updateAccountResult = await updateAccountApiWithResult(apiParamater);
    if (updateAccountResult) {
        props.account = updatedAccount;
    }
}
*/

const RefreshSession: HandlerType = async props => {
    if (props?.account?.billToId) {
        props.billTo = await getBillTo({ billToId: props.account.billToId })
    }
    // load billto linked to account
    // save both account and billto to state
    // ensure 1st address updates default one (hide initially)
}

const UpdateState: HandlerType = props => {
    if(!props.statusError){
        (props.dispatch as customDispatch)({
            type: "Affinity/CreateAccount/Step1CreateAccount",
            firstName: props.parameter.firstName,
            lastName: props.parameter.lastName,
            contactNumber: props.parameter.contactNumber,
            emailAddress: props.parameter.emailAddress,
            billTo: props.billTo!
        });
    }
}

const Tracking: HandlerType = props => {
    //
}

const chain = [
    CreateAccount,
    // UpdateAccount,
    RefreshSession,
    FireOnError,
    UpdateState,
    Tracking,
];

const createAccount = createHandlerChainRunner(chain, "CreateAccount");
export default createAccount;